// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Witness = t.struct({
    firstName: t.String,
    lastName: t.String
}, {
    name: 'Witness',
    strict: true
});

export const getDefaultState = () => new Witness({
    firstName: '',
    lastName: ''
});

export default Witness;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/witness.js